module.exports = __webpack_public_path__ + "beyaz mutfak.jpeg?ca37456c4b4dccf4afee17da236f52d0";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/beyaz mutfak.jpeg
// module id = 332
// module chunks = 0